import UICountryCode from './UICountryCode'
export default UICountryCode
